// Shared tenant brand-color helpers. Converts a #RRGGBB hex into the Tailwind
// "H S% L%" token used by --primary, and applies/clears it on :root.

export const LOGIN_BRAND_KEY = "reason_login_brand";

export function hexToHsl(hex) {
  if (!hex || typeof hex !== "string") return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue = 0, sat = 0;
  const lum = (max + min) / 2;
  if (max !== min) {
    const d = max - min;
    sat = lum > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = (g - b) / d + (g < b ? 6 : 0);
    else if (max === g) hue = (b - r) / d + 2;
    else hue = (r - g) / d + 4;
    hue /= 6;
  }
  return {
    triple: `${Math.round(hue * 360)} ${Math.round(sat * 100)}% ${Math.round(lum * 100)}%`,
    lum,
  };
}

function _applyHex(hex) {
  const root = document.documentElement;
  const hsl = hexToHsl(hex);
  if (!hsl) return false;
  root.style.setProperty("--primary", hsl.triple);
  root.style.setProperty("--ring", hsl.triple);
  root.style.setProperty("--primary-foreground", hsl.lum > 0.62 ? "0 0% 10%" : "0 0% 100%");
  return true;
}

export function applyBrandPrimaryRaw(hex) { return _applyHex(hex); }

export function applyBrandPrimary(hex) {
  // Per-user accent (Design System → Appearance) takes precedence over the tenant brand color.
  try {
    const prefs = JSON.parse(localStorage.getItem("reason_ux_prefs_v1") || "{}");
    if (prefs && prefs.accent && prefs.accent !== "default") return false;
  } catch { /* ignore */ }
  return _applyHex(hex);
}

export function clearBrandPrimary() {
  const root = document.documentElement;
  // Don't wipe a user-selected accent (Design System → Appearance) — it owns --primary.
  try {
    const prefs = JSON.parse(localStorage.getItem("reason_ux_prefs_v1") || "{}");
    if (prefs && prefs.accent && prefs.accent !== "default") return;
  } catch { /* ignore */ }
  root.style.removeProperty("--primary");
  root.style.removeProperty("--ring");
  root.style.removeProperty("--primary-foreground");
}
